/**
 * Morph JavaScript
 *
 * This file defines behaviors of
 * the Morph block.
 */
import { gsap } from 'gsap';
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin.js';

gsap.registerPlugin(MorphSVGPlugin);

document.querySelectorAll('.morph')?.forEach((wrap) => {
	const svg = wrap.querySelector('.morph__svg');
	const blurbs = [...wrap.querySelectorAll('.morph__item')];
	if (svg && blurbs.length) {
		blurbs[0].classList.add('active');
		const paths = [...svg.querySelectorAll(':scope > path')];
		if (paths.length) {
			const { delay } = wrap.dataset;
			const speed = 0.5;
			const basis = paths[0];
			paths.push(paths.shift());
			blurbs.push(blurbs.shift());
			const tl = gsap.timeline({
				repeat: -1,
				defaults: { duration: speed, delay },
			});
			paths.forEach((path, i) => {
				tl.to(
					basis,
					{
						morphSVG: path,
						onStart: () => {
							blurbs.forEach((blurb, j) =>
								blurb.classList.toggle('active', i === j)
							);
						},
					},
					`+=${speed}`
				);
			});
		}
	}
});
